import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

export const fetchAllFacilities = createAsyncThunk(
  "facility/fetchAllFacilities",
  async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/allfacility`);     
        return response.data.data;  
      } catch (error) {
        throw new Error(error.response?.data?.message || error.message);  
      }
   
  }
);

export const addFacility = createAsyncThunk(
  "facility/addFacility", 
  async (FacilityTitle, FacilityDescription, CreatedBy) => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/facilityadd`,{FacilityTitle, FacilityDescription, CreatedBy});
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
 
});

const facilitySlice = createSlice({
  name: "facility",
  initialState: {
    facilityData: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFacilities.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllFacilities.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.facilityData  = action.payload;
        state.error = null; 
      })
      .addCase(fetchAllFacilities.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message; 
      })
      
  },
});

export default facilitySlice.reducer;
